export const FEEDBACK = {
  URL: '/feedback',
  TITLE: 'Обратная связь'
}


// WEBPACK FOOTER //
// ./src/features/Feedback/links.js